// extracted by mini-css-extract-plugin
var _1 = "VersionChanges-module__animateUploadProgressBarWidth--q5hMZ";
var _2 = "VersionChanges-module__animatedBackground--qd61r";
var _3 = "VersionChanges-module__bar--Rvef9";
var _4 = "VersionChanges-module__barButton--xcl1H";
var _5 = "VersionChanges-module__barContainer--IQMmg";
var _6 = "VersionChanges-module__barContent--Q0g62";
var _7 = "VersionChanges-module__changes--Hj_7u";
var _8 = "VersionChanges-module__content--zP2dC";
var _9 = "VersionChanges-module__contentContainer--X_9sX";
var _a = "VersionChanges-module__contentGrid--qOG5T";
var _b = "VersionChanges-module__cyclingButtons--sOatL";
var _c = "VersionChanges-module__cyclingContainer--ScIg9";
var _d = "VersionChanges-module__cyclingLabel--IaC82";
var _e = "VersionChanges-module__footer--hJF_c";
var _f = "VersionChanges-module__footerContainer--ECnjn";
var _10 = "VersionChanges-module__footerWaypoint--jkk3x";
var _11 = "VersionChanges-module__hide--N6Bd2";
var _12 = "VersionChanges-module__isRightPanelOpen--JzFTx";
var _13 = "VersionChanges-module__isSticky--OIBdo";
var _14 = "VersionChanges-module__scrollContainer--js_6o";
var _15 = "VersionChanges-module__showDivider--AhfCN";
var _16 = "VersionChanges-module__versionMeta--t3Fds";
var _17 = "VersionChanges-module__versionMetaContainer--cxpsA";
var _18 = "VersionChanges-module__wrapper--iDNgj";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "bar", _4 as "barButton", _5 as "barContainer", _6 as "barContent", _7 as "changes", _8 as "content", _9 as "contentContainer", _a as "contentGrid", _b as "cyclingButtons", _c as "cyclingContainer", _d as "cyclingLabel", _e as "footer", _f as "footerContainer", _10 as "footerWaypoint", _11 as "hide", _12 as "isRightPanelOpen", _13 as "isSticky", _14 as "scrollContainer", _15 as "showDivider", _16 as "versionMeta", _17 as "versionMetaContainer", _18 as "wrapper" }
